import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=147661ab"
import script from "./CalendarIcon.vue?vue&type=script&lang=ts"
export * from "./CalendarIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports